(() => {
  document.querySelectorAll('[data-cmb]').forEach(root => {
    if (root.dataset.cmbReady) return;
    root.dataset.cmbReady = 'true';
    const dialog = root.querySelector('.cmb__dialog');
    const panels = [...root.querySelectorAll('[data-cmb-panel]')];
    let current = 0;
    let opener;
    function show(index) {
      current = (index + panels.length) % panels.length;
      panels.forEach((panel, i) => { panel.hidden = i !== current; });
      dialog.setAttribute('aria-label', panels[current].querySelector('h2').textContent);
      root.querySelector('[data-cmb-position]').textContent = `${current + 1} / ${panels.length}`;
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0;
    }
    root.querySelectorAll('[data-cmb-open]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      show(Number(button.dataset.cmbOpen));
    }));
    root.querySelectorAll('[data-cmb-lesson]').forEach(lesson => {
      const feedback = lesson.querySelector('[data-cmb-feedback]');
      const procedure = lesson.querySelector('[data-cmb-procedure]');
      lesson.querySelectorAll('[data-cmb-answer]').forEach(button => button.addEventListener('click', () => {
        const correct = button.dataset.cmbAnswer === '0';
        lesson.querySelectorAll('[data-cmb-answer]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        feedback.textContent = correct ? 'Yes. Here is the approved next step.' : 'Try the other choice. Here is the approved next step.';
        feedback.hidden = false;
        procedure.hidden = false;
      }));
    });
    root.querySelector('.cmb__close').addEventListener('click', () => dialog.close());
    root.querySelector('[data-cmb-prev]').addEventListener('click', () => show(current - 1));
    root.querySelector('[data-cmb-next]').addEventListener('click', () => show(current + 1));
    dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
})();
